var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpielsteineWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:#010101;}.cls-1,.cls-5,.cls-6,.cls-4{stroke:#020202;}.cls-1,.cls-6{stroke-width:1.5px;}.cls-7{fill:#f4d6e7;}.cls-8{fill:#f7ee5a;}.cls-9{fill:#fff;}.cls-5,.cls-10,.cls-3,.cls-11,.cls-12,.cls-13,.cls-4{stroke-width:2px;}.cls-5,.cls-6{fill:none;}.cls-10{fill:#f37476;}.cls-10,.cls-3,.cls-11,.cls-12,.cls-13{stroke:#010101;stroke-miterlimit:10;}.cls-11{fill:#84b1df;}.cls-12{fill:#a5ce4a;}.cls-13{fill:#faa53e;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.64,
    y: 0.2,
    width: 124.54,
    height: 92.91,
    transform: "translate(.15 -.26) rotate(.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.64,
    y: 29.52,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 25.64,
    y: 30.52,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 20.64,
    y: 24.52,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 21.64,
    y: 25.52,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.21,14.58c.72-.65,1.85,0,1.65,.95l-1.63,7.65c-.09,.42,.1,.86,.48,1.07l6.77,3.91c.84,.48,.57,1.76-.4,1.86l-7.78,.82c-.43,.05-.78,.36-.87,.79l-1.63,7.65c-.2,.95-1.5,1.08-1.89,.2l-3.18-7.14c-.18-.4-.59-.63-1.02-.59l-7.78,.82c-.96,.1-1.49-1.09-.77-1.74l5.81-5.23c.32-.29,.42-.75,.24-1.15l-3.18-7.14c-.39-.89,.57-1.76,1.41-1.27l6.77,3.91c.38,.22,.85,.17,1.17-.12l5.81-5.23,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.71,15.14c.18-.16,.46,0,.41,.24l-1.63,7.65c-.16,.74,.18,1.5,.84,1.88l6.77,3.91c.21,.12,.14,.44-.1,.47l-7.78,.82c-.75,.08-1.37,.64-1.53,1.38l-1.63,7.65c-.05,.24-.37,.27-.47,.05l-3.18-7.14c-.31-.69-1.03-1.11-1.78-1.03l-7.78,.82c-.24,.03-.37-.27-.19-.43l5.81-5.23c.56-.51,.74-1.32,.43-2.01l-3.18-7.14c-.1-.22,.14-.44,.35-.32l6.77,3.91c.66,.38,1.48,.29,2.05-.22l5.81-5.23v-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.92,43.65c.48-.84,1.76-.58,1.86,.38l.55,4.99c.05,.43,.37,.78,.79,.87l4.91,1.02c.95,.2,1.09,1.49,.21,1.89l-4.57,2.07c-.39,.18-.63,.59-.58,1.02l.55,4.99c.11,.96-1.08,1.5-1.73,.78l-3.38-3.71c-.29-.32-.76-.42-1.15-.24l-4.57,2.07c-.88,.4-1.76-.56-1.28-1.41l2.48-4.36c.21-.38,.16-.85-.13-1.17l-3.38-3.71c-.65-.72,0-1.85,.94-1.65l4.91,1.02c.42,.09,.86-.11,1.07-.48l2.48-4.36h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,44.03c.12-.21,.44-.14,.47,.1l.55,4.99c.08,.75,.64,1.37,1.39,1.52l4.91,1.02c.24,.05,.27,.37,.05,.47l-4.57,2.07c-.69,.31-1.1,1.03-1.02,1.79l.55,4.99c.03,.24-.27,.38-.43,.2l-3.38-3.71c-.51-.56-1.32-.73-2.01-.42l-4.57,2.07c-.22,.1-.44-.14-.32-.35l2.48-4.36c.38-.66,.28-1.48-.23-2.04l-3.38-3.71c-.16-.18,0-.46,.24-.41l4.91,1.02c.74,.15,1.5-.19,1.87-.85l2.48-4.36v-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.44,46.76c.15-.96,1.43-1.17,1.88-.31l.71,1.37c.2,.38,.62,.6,1.05,.53l1.52-.25c.96-.16,1.55,1,.87,1.69l-1.09,1.1c-.3,.31-.38,.78-.18,1.16l.71,1.37c.44,.86-.47,1.79-1.34,1.35l-1.38-.69c-.39-.19-.86-.12-1.16,.19l-1.09,1.1c-.68,.69-1.85,.1-1.7-.85l.23-1.53c.07-.43-.15-.85-.54-1.04l-1.38-.69c-.87-.43-.67-1.72,.29-1.88l1.52-.25c.43-.07,.76-.41,.83-.84l.23-1.53h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.18,46.87c.04-.24,.36-.29,.47-.08l.71,1.37c.35,.67,1.09,1.05,1.84,.92l1.52-.25c.24-.04,.39,.25,.22,.42l-1.09,1.1c-.53,.54-.66,1.36-.31,2.03l.71,1.37c.11,.22-.12,.45-.33,.34l-1.38-.69c-.68-.34-1.5-.21-2.03,.33l-1.09,1.1c-.17,.17-.46,.03-.42-.21l.23-1.53c.11-.75-.27-1.49-.94-1.83l-1.38-.69c-.22-.11-.17-.43,.07-.47l1.52-.25c.75-.12,1.33-.71,1.45-1.46l.23-1.53h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.21,12.58c.72-.65,1.85,0,1.65,.95l-1.63,7.65c-.09,.42,.1,.86,.48,1.07l6.77,3.91c.84,.48,.57,1.76-.4,1.86l-7.78,.82c-.43,.05-.78,.36-.87,.79l-1.63,7.65c-.2,.95-1.5,1.08-1.89,.2l-3.18-7.14c-.18-.4-.59-.63-1.02-.59l-7.78,.82c-.96,.1-1.49-1.09-.77-1.74l5.81-5.23c.32-.29,.42-.75,.24-1.15l-3.18-7.14c-.39-.89,.57-1.76,1.41-1.27l6.77,3.91c.38,.22,.85,.17,1.17-.12l5.81-5.23,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.71,13.14c.18-.16,.46,0,.41,.24l-1.63,7.65c-.16,.74,.18,1.5,.84,1.88l6.77,3.91c.21,.12,.14,.44-.1,.47l-7.78,.82c-.75,.08-1.37,.64-1.53,1.38l-1.63,7.65c-.05,.24-.37,.27-.47,.05l-3.18-7.14c-.31-.69-1.03-1.11-1.78-1.03l-7.78,.82c-.24,.03-.37-.27-.19-.43l5.81-5.23c.56-.51,.74-1.32,.43-2.01l-3.18-7.14c-.1-.22,.14-.44,.35-.32l6.77,3.91c.66,.38,1.48,.29,2.05-.22l5.81-5.23v-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.92,41.65c.48-.84,1.76-.58,1.86,.38l.55,4.99c.05,.43,.37,.78,.79,.87l4.91,1.02c.95,.2,1.09,1.49,.21,1.89l-4.57,2.07c-.39,.18-.63,.59-.58,1.02l.55,4.99c.11,.96-1.08,1.5-1.73,.78l-3.38-3.71c-.29-.32-.76-.42-1.15-.24l-4.57,2.07c-.88,.4-1.76-.56-1.28-1.41l2.48-4.36c.21-.38,.16-.85-.13-1.17l-3.38-3.71c-.65-.72,0-1.85,.94-1.65l4.91,1.02c.42,.09,.86-.11,1.07-.48l2.48-4.36h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.57,42.03c.12-.21,.44-.14,.47,.1l.55,4.99c.08,.75,.64,1.37,1.39,1.52l4.91,1.02c.24,.05,.27,.37,.05,.47l-4.57,2.07c-.69,.31-1.1,1.03-1.02,1.79l.55,4.99c.03,.24-.27,.38-.43,.2l-3.38-3.71c-.51-.56-1.32-.73-2.01-.42l-4.57,2.07c-.22,.1-.44-.14-.32-.35l2.48-4.36c.38-.66,.28-1.48-.23-2.04l-3.38-3.71c-.16-.18,0-.46,.24-.41l4.91,1.02c.74,.15,1.5-.19,1.87-.85l2.48-4.36v-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.44,44.76c.15-.96,1.43-1.17,1.88-.31l.71,1.37c.2,.38,.62,.6,1.05,.53l1.52-.25c.96-.16,1.55,1,.87,1.69l-1.09,1.1c-.3,.31-.38,.78-.18,1.16l.71,1.37c.44,.86-.47,1.79-1.34,1.35l-1.38-.69c-.39-.19-.86-.12-1.16,.19l-1.09,1.1c-.68,.69-1.85,.1-1.7-.85l.23-1.53c.07-.43-.15-.85-.54-1.04l-1.38-.69c-.87-.43-.67-1.72,.29-1.88l1.52-.25c.43-.07,.76-.41,.83-.84l.23-1.53h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.18,44.87c.04-.24,.36-.29,.47-.08l.71,1.37c.35,.67,1.09,1.05,1.84,.92l1.52-.25c.24-.04,.39,.25,.22,.42l-1.09,1.1c-.53,.54-.66,1.36-.31,2.03l.71,1.37c.11,.22-.12,.45-.33,.34l-1.38-.69c-.68-.34-1.5-.21-2.03,.33l-1.09,1.1c-.17,.17-.46,.03-.42-.21l.23-1.53c.11-.75-.27-1.49-.94-1.83l-1.38-.69c-.22-.11-.17-.43,.07-.47l1.52-.25c.75-.12,1.33-.71,1.45-1.46l.23-1.53h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94.62,
    y: 52.68,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94.62,
    y: 29.23,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.98,
    y: 52.68,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.08,29.23h0c6.13,0,11.1,4.97,11.1,11.1h0c0,6.13-4.97,11.1-11.1,11.1h0c-6.13,0-11.1-4.97-11.1-11.1h0c0-6.13,4.97-11.1,11.1-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.72,27.52h-9.48c-1.28,0-2.08-1.38-1.44-2.49l4.74-8.21,4.74-8.21c.64-1.11,2.24-1.11,2.87,0l4.74,8.21,4.74,8.21c.64,1.11-.16,2.49-1.44,2.49h-9.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 89.62,
    y: 49.68,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 89.62,
    y: 26.23,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 65.98,
    y: 49.68,
    width: 22.2,
    height: 22.2,
    rx: 3.86,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M77.08,26.23h0c6.13,0,11.1,4.97,11.1,11.1h0c0,6.13-4.97,11.1-11.1,11.1h0c-6.13,0-11.1-4.97-11.1-11.1h0c0-6.13,4.97-11.1,11.1-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.72,24.52h-9.48c-1.28,0-2.08-1.38-1.44-2.49l4.74-8.21,4.74-8.21c.64-1.11,2.24-1.11,2.87,0l4.74,8.21,4.74,8.21c.64,1.11-.16,2.49-1.44,2.49h-9.47Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.41,
    y: 50.79,
    width: 3.23,
    height: 3.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpielsteineWeb);
export default __webpack_public_path__ + "static/media/spielsteine_web.7edcfbc5f177c4667d8e56bcc20420fd.svg";
export { ForwardRef as ReactComponent };